export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";